import React from 'react'
import styles from './styles.css'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
// import SendToSign from './SendToSign'
// // import Status from './Status'
// // import UpdateInformation from './UpdateInformation'
// // import UpdateSigners from './UpdateSigners'
import Ready from './Ready'
// import AdvancedSettings from './AdvancedSettings'

@withGraphQL(gql`
  query getTemplate($templateId: ID) {
    template(templateId: $templateId) {
      _id
      name
      fields{
        id
        type
      }
      feaSignersRoles {
        name
      }
      faceSignersRoles {
        name
      }
    }
  }
`)
export default class Document extends React.Component {
  static propTypes = {
    template: PropTypes.object
  }

  renderResume() {
    return <Ready template={this.props.template} />
  }

  // renderUpdateInformation () {
  //   if (this.props.template.signatureRequested) return
  //   return <UpdateInformation template={this.props.template} />
  // }

  // renderUpdateSigners () {
  //   if (this.props.template.signatureRequested) return
  //   if (this.props.template.isPersonal) return
  //   return <UpdateSigners template={this.props.template} />
  // }

  // renderAdvancedSettings () {
  //   if (this.props.template.signatureRequested) return
  //   if (this.props.template.isPersonal) return
  //   return <AdvancedSettings template={this.props.template} />
  // }

  updateNumeroFirmasOcupadas() {
    let fields = this.props.template.fields
    let numFirmas = 0;
    console.log("Analizando fields ", fields)
    if (fields && fields.length > 0) {
      fields.forEach(field => {
        if (field.type === 'signature') {
          numFirmas++
        }
      })
      console.log("Hay " + numFirmas + " ")
      return numFirmas;
    }
    return 0
  }

  renderFirmasDisponibles() {
    let firmasUsadas = this.updateNumeroFirmasOcupadas()
    let numeroFirmasUsadas = Math.max(1, firmasUsadas)
    let numeroFirmasAvanzadas = this.props.template.feaSignersRoles ? this.props.template.feaSignersRoles.length : 0
    // let numeroFirmasFaciales= this.props.template.faceSignersRoles ? this.props.template.faceSignersRoles.length : 0
    return (
      <div>
        <div>Firmas simples a ocupar: {numeroFirmasUsadas}</div>
        <div>Firmas avanzadas a ocupar: {numeroFirmasAvanzadas}</div> 
      </div>
    )
  }

  // <div>Firmas faciales a ocupar: {numeroFirmasFaciales}</div>

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <h3>{this.props.template.name}</h3>
            <p>{this.renderFirmasDisponibles()}</p>
          </div>
          <div className="content">{this.renderResume()}</div>
        </div>
        {/* {this.renderUpdateInformation()}
        {this.renderUpdateSigners()}
        {this.renderAdvancedSettings()} */}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Templates/Template/index.js